<template>
  <div>
    <b-card class="mb-1" bg-variant="dark" border-variant="danger">
      <b-card-header header-bg-variant="secondary"><h5>Steam Keys</h5></b-card-header>
      <div id="loadingDiv" class="text-center" style="padding-top: 5px" v-if="!keyStoreStatusLoaded">
        <b-spinner label="Loading..." variant="danger"/>
      </div>
      <div id="keyStoreContentDiv" v-if="keyStoreStatusLoaded">
        <span v-if="keyStoreStatus==='Online'">
          <b-card-text>Steam Keystore is currently: {{ keyStoreStatus }}</b-card-text>
          <b-card-text>Unclaimed Steam keys available: {{ unclaimedKeyCount }}</b-card-text>
          <b-button id="claimSteamKey" @click="claimKey" variant="outline-danger" class="mr-2"
                    v-if="unclaimedKeyCount > 0">
            Claim a key
          </b-button>
          <b-button id="addSteamKey" @click="addKey" variant="outline-danger">Add a key</b-button>
        </span>
        <span v-else-if="keyStoreStatus==='Offline'">
          <b-card-text>
            Unable to retrieve Steam Keystore data.<br/>  If this error persists, please contact the administrators.
          </b-card-text>
        </span>
      </div>
    </b-card>

    <b-modal id="addKeyModal"
             ref="addKeyModal"
             @hide="closeAddKeyModal"
             title="Add a Steam Key"
             v-model="addKeyModalShow"
             header-bg-variant="secondary"
             header-class="default-color"
             body-bg-variant='dark'
             ok-variant="outline-danger"
             footer-bg-variant="dark"
             hide-footer>
      <SteamKeyAddForm v-bind:id-token="idToken" v-on:close="closeAddKeyModal"/>
    </b-modal>

    <b-modal id="claimKeyModal"
             ref="claimKeyModal"
             @hide="closeClaimKeyModal"
             title="Claim a Steam Key"
             v-model="claimKeyModalShow"
             header-bg-variant="secondary"
             header-class="default-color"
             body-bg-variant='dark'
             ok-variant="outline-danger"
             footer-bg-variant="dark"
             hide-footer>
      <SteamKeyClaimForm v-bind:id-token="idToken" v-bind:unclaimed-keys="unclaimedKeys"/>
    </b-modal>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify'
  import axios from 'axios'
  import SteamKeyAddForm from './SteamKeyAddForm'
  import SteamKeyClaimForm from './SteamKeyClaimForm'
  import JQuery from 'jquery'

  export default {
    name: 'SteamCard',
    components: { SteamKeyAddForm, SteamKeyClaimForm },
    data () {
      return {
        keyStoreStatusLoaded: false,
        keyStoreStatus: 'Offline',
        unclaimedKeyCount: 0,
        unclaimedKeys: '',
        idToken: null,
        addKeyModalShow: false,
        claimKeyModalShow: false
      }
    },
    mounted () {
      let $ = JQuery
      $(this.$refs.claimKeyModal).on('hidden.bs.modal', this.closeClaimKeyModal())
      $(this.$refs.addKeyModal).on('hidden.bs.modal', this.closeAddKeyModal())
      this.getKeyStoreStatus()
    },
    methods: {
      async getKeyStoreStatus () {

        await Auth.currentAuthenticatedUser().then(user => {
          this.idToken = user.signInUserSession.idToken.jwtToken
        }).catch(err => {
          console.log('Error retrieving logged in User info: ' + err)
          this.keyStoreStatusLoaded = true
        })

        if (this.idToken) {
          let keyStoreGetStatusRequest = {
            method: 'GET',
            url: 'https://3deddkpozj.execute-api.us-east-2.amazonaws.com/test/apopkeystore',
            crossDomain: true,
            headers: {
              'content-type': 'application/json',
              'x-apop-token': this.idToken
            }
          }

          await axios(keyStoreGetStatusRequest).then(response => {
            this.unclaimedKeyCount = response.data.Count
            this.unclaimedKeys = response.data.Items
            this.keyStoreStatus = 'Online'
            this.keyStoreStatusLoaded = true
          }).catch(err => {
            console.log(err)
            this.keyStoreStatusLoaded = true
          })
        }
      },
      addKey () {
        this.addKeyModalShow = true
      },
      claimKey () {
        this.claimKeyModalShow = true
      },
      closeAddKeyModal () {
        this.getKeyStoreStatus()
        this.addKeyModalShow = false
      },
      closeClaimKeyModal () {
        this.getKeyStoreStatus()
        this.claimKeyModalShow = false
      }
    }
  }

</script>
